import { createSlice } from "@reduxjs/toolkit";
import { Document } from "types/Document";
import { explodeIndicatorId } from "utils/utils";

interface DocumentSlice {
  documents: Document[];
  document: Document | null;
  selectedDocumentId: string;
  inEditingDocumentId: string;
  roleEditingDocumentId: string;
}

const initialState: DocumentSlice = {
  documents: [],
  document: null,
  // documentInEditing: null,
  selectedDocumentId: "",
  inEditingDocumentId: "",
  roleEditingDocumentId: "",
};


export const DocumentsSlice = createSlice({
  name: "documents",
  initialState: initialState,
  reducers: {
    addDocuments: (state, action) => {
      state.documents = action.payload;
    },
    addDocument: (state, action) => {
      const tmp_now = (new Date()).toISOString();
      const title = action.payload.title;
      const subtitle = action.payload.subtitle;
      const description = action.payload.description;
      const code = action.payload.code;
      const documentId = action.payload.document;
      const _id = action.payload._id;
      const timePeriods = action.payload.timePeriods;
      const targets = action.payload.targets != null ? action.payload.targets : [];
      const isActive = action.payload.isActive;
      const newDocument = {
        title: title,
        code: code,
        subtitle: subtitle,
        description: description,
        targets: targets,
        _id: _id,
        updatedAt: tmp_now,
        createdAt: tmp_now,
        timePeriods: timePeriods,
        isActive: isActive
      }

      if (documentId != null) {
        const targetsToCopy = state.documents.filter(document => document._id === documentId)[0].targets;
        const newTargetsCleared = targetsToCopy.map((target) => {
          const newSubtargets = target.subtargets.map((subtarget) => {
            const newActions = subtarget.actions.map((action) => {
              const newIndicators = action.indicators.map((indicator) => {
                return {
                  ...indicator,
                  attachments: [] as any[],
                  oldAttachments: [] as any[],
                  inputType: "",
                  placeholder: "",
                  value: "",
                }
              });
              return {
                ...action,
                indicators: newIndicators,
              }
            });
            return {
              ...subtarget,
              actions: newActions,
            }
          });
          return {
            ...target,
            subtargets: newSubtargets,
          }
        });

        const newDocumentWithTargets = {
          ...newDocument,
          targets: newTargetsCleared,
        }
        state.documents.push(newDocumentWithTargets);
      } else {

        const newDocumentWithoutTargets = {
          ...newDocument,
        }
        state.documents.push(newDocument);
      }
    },
    removeDocument: (state, action) => {
      const documentId = action.payload.documentId;
      state.documents = state.documents.filter((document) => document._id !== documentId);
    },
    updateDocument: (state, action) => {
      const targets = action.payload.targets;
      const documentId = action.payload.documentId;
      const indexOfDocumentToUpdate = state.documents.findIndex(document => document._id === documentId);

      if (targets != null) {
        //update the document targets
        state.documents[indexOfDocumentToUpdate] = {
          ...state.documents[indexOfDocumentToUpdate],
          targets: targets,
        }


      } else {
        //update the document attributes
        const newValues = {
          code: action.payload.code,
          title: action.payload.title,
          subtitle: action.payload.subtitle,
          description: action.payload.description,
          isActive: action.payload.isActive,
        }
        state.documents[indexOfDocumentToUpdate] = {
          ...state.documents[indexOfDocumentToUpdate],
          ...newValues,
        }

      }

    },

    setSelectedDocumentId: (state, action) => {
      state.selectedDocumentId = action.payload.documentId;
    },

    setDocumentInEditingId: (state, action) => {
      state.inEditingDocumentId = action.payload.documentId;
    },
    removeDocumentInEditingId: (state) => {
      state.inEditingDocumentId = "";
    },


    updateInEditingDocumentTarget: (state, action) => {
      const newTargetIndex = action.payload.targetIndex;
      const updatedValues = {
        title: action.payload.targetTitle,
        subtitle: action.payload.targetSubtitle,
        description: action.payload.targetDescription,
        id: action.payload.id,
      };

      const indexOfTargetToUpdate = state.documents.find((document) => document._id === state.inEditingDocumentId).targets.findIndex(target => target.index === newTargetIndex);
      state.documents.find((document) => document._id === state.inEditingDocumentId).targets[indexOfTargetToUpdate] = {
        ...state.documents.find((document) => document._id === state.inEditingDocumentId).targets[indexOfTargetToUpdate],
        ...updatedValues,

      }
    },

    updateInEditingDocumentSubtarget: (state, action) => {
      const targetIndex = action.payload.targetIndex;
      const newSubtargetIndex = action.payload.subtargetIndex;
      const updatedValues = {
        title: action.payload.subtargetTitle,
        subtitle: action.payload.subtargetSubtitle,
        description: action.payload.subtargetDescription,
      };
      const indexOfTargetToUpdate = state.documents.find((document) => document._id === state.inEditingDocumentId).targets.findIndex(target => target.index === targetIndex);
      const indexOfSubtargetToUpdate = state.documents.find((document) => document._id === state.inEditingDocumentId).targets[indexOfTargetToUpdate].subtargets.findIndex(subtarget => subtarget.index === newSubtargetIndex);

      state.documents.find((document) => document._id === state.inEditingDocumentId).targets[indexOfTargetToUpdate].subtargets[indexOfSubtargetToUpdate] = {
        ...state.documents.find((document) => document._id === state.inEditingDocumentId).targets[indexOfTargetToUpdate].subtargets[indexOfSubtargetToUpdate],
        ...updatedValues,
      }
    },
    updateInEditingDocumentAction: (state, action) => {
      const targetIndex = action.payload.targetIndex;
      const subtargetIndex = action.payload.subtargetIndex;
      const newActionIndex = action.payload.actionIndex;
      const updatedValues: any = {
        title: action.payload.actionTitle,
        subtitle: action.payload.actionSubtitle,
        description: action.payload.actionDescription,
        id: action.payload.id,
      };
      const indexOfTargetToUpdate = state.documents.find((document) => document._id === state.inEditingDocumentId).targets.findIndex(target => target.index === targetIndex);
      const indexOfSubtargetToUpdate = state.documents.find((document) => document._id === state.inEditingDocumentId).targets[indexOfTargetToUpdate].subtargets.findIndex(subtarget => subtarget.index === subtargetIndex);
      const indexOfActionToUpdate = state.documents.find((document) => document._id === state.inEditingDocumentId).targets[indexOfTargetToUpdate].subtargets[indexOfSubtargetToUpdate].actions.findIndex(action => action.index === newActionIndex);
      state.documents.find((document) => document._id === state.inEditingDocumentId).targets[indexOfTargetToUpdate].subtargets[indexOfSubtargetToUpdate].actions[indexOfActionToUpdate] = {
        ...state.documents.find((document) => document._id === state.inEditingDocumentId).targets[indexOfTargetToUpdate].subtargets[indexOfSubtargetToUpdate].actions[indexOfActionToUpdate],
        ...updatedValues,
      }
    },


    updateInEditingDocumentIndicator: (state, action) => {
      const targetIndex = action.payload.targetIndex;
      const subtargetIndex = action.payload.subtargetIndex;
      const actionIndex = action.payload.actionIndex;
      const newIndicatorIndex = action.payload.indicatorIndex;

      let newValues = {} as any;
      const newLabels = action.payload.timePeriods;
      for (const newLabel in newLabels) {
        newValues[newLabel] = "";
      }


      if (action.payload?.values) {

        const updatedValues = {
          title: action.payload.indicatorTitle,
          subtitle: action.payload.indicatorSubtitle,
          description: action.payload.indicatorDescription,
          pnrr: action.payload.indicatorPnrr,
          sdg: action.payload.indicatorSdg,
          values: newValues,
          sources: action.payload.indicatorSources,
          targetValue: action.payload.targetValue,
          organizationalUnit: action.payload.organizationalUnit,
          anvur: action.payload.anvur,
        };
        const indexOfTargetToUpdate = state.documents.find((document) => document._id === state.inEditingDocumentId).targets.findIndex(target => target.index === targetIndex);
        const indexOfSubtargetToUpdate = state.documents.find((document) => document._id === state.inEditingDocumentId).targets[indexOfTargetToUpdate].subtargets.findIndex(subtarget => subtarget.index === subtargetIndex);
        const indexOfActionToUpdate = state.documents.find((document) => document._id === state.inEditingDocumentId).targets[indexOfTargetToUpdate].subtargets[indexOfSubtargetToUpdate].actions.findIndex(action => action.index === actionIndex);
        const indexOfIndicatorToUpdate = state.documents.find((document) => document._id === state.inEditingDocumentId).targets[indexOfTargetToUpdate].subtargets[indexOfSubtargetToUpdate].actions[indexOfActionToUpdate].indicators.findIndex(indicator => indicator.index === newIndicatorIndex);
        state.documents.find((document) => document._id === state.inEditingDocumentId).targets[indexOfTargetToUpdate].subtargets[indexOfSubtargetToUpdate].actions[indexOfActionToUpdate].indicators[indexOfIndicatorToUpdate] = {
          ...state.documents.find((document) => document._id === state.inEditingDocumentId).targets[indexOfTargetToUpdate].subtargets[indexOfSubtargetToUpdate].actions[indexOfActionToUpdate].indicators[indexOfIndicatorToUpdate],
          ...updatedValues,
        }
      } else {
        const updatedValues = {
          title: action.payload.indicatorTitle,
          subtitle: action.payload.indicatorSubtitle,
          description: action.payload.indicatorDescription,
          pnrr: action.payload.indicatorPnrr,
          sdg: action.payload.indicatorSdg,
          sources: action.payload.indicatorSources,
          targetValue: action.payload.targetValue,
          organizationalUnit: action.payload.organizationalUnit,
          anvur: action.payload.anvur,
        };
        const indexOfTargetToUpdate = state.documents.find((document) => document._id === state.inEditingDocumentId).targets.findIndex(target => target.index === targetIndex);
        const indexOfSubtargetToUpdate = state.documents.find((document) => document._id === state.inEditingDocumentId).targets[indexOfTargetToUpdate].subtargets.findIndex(subtarget => subtarget.index === subtargetIndex);
        const indexOfActionToUpdate = state.documents.find((document) => document._id === state.inEditingDocumentId).targets[indexOfTargetToUpdate].subtargets[indexOfSubtargetToUpdate].actions.findIndex(action => action.index === actionIndex);
        const indexOfIndicatorToUpdate = state.documents.find((document) => document._id === state.inEditingDocumentId).targets[indexOfTargetToUpdate].subtargets[indexOfSubtargetToUpdate].actions[indexOfActionToUpdate].indicators.findIndex(indicator => indicator.index === newIndicatorIndex);
        state.documents.find((document) => document._id === state.inEditingDocumentId).targets[indexOfTargetToUpdate].subtargets[indexOfSubtargetToUpdate].actions[indexOfActionToUpdate].indicators[indexOfIndicatorToUpdate] = {
          ...state.documents.find((document) => document._id === state.inEditingDocumentId).targets[indexOfTargetToUpdate].subtargets[indexOfSubtargetToUpdate].actions[indexOfActionToUpdate].indicators[indexOfIndicatorToUpdate],
          ...updatedValues,
        }
      }


    },

    addInEditingDocumentAction: (state, action) => {
      const targetIndex = action.payload.targetIndex;
      const subtargetIndex = action.payload.subtargetIndex;
      const newAction = {
        index: action.payload.actionIndex,
        id: action.payload.id,
        title: action.payload.actionTitle,
        subtitle: action.payload.actionSubtitle,
        description: action.payload.actionDescription,
        indicators: [] as any[],
        _id: action.payload._id,

      };

      state.documents = state.documents.map((document) => {
        if (document._id === state.inEditingDocumentId) {
          document.targets.map((target) => {
            if (target.index === targetIndex) {
              target.subtargets.map((subtarget) => {
                if (subtarget.index === subtargetIndex) {
                  subtarget.actions = [...subtarget.actions, newAction];
                }
              });
            }
          });
        }
        return document;
      })
    },

    addInEditingDocumentSubtarget: (state, action) => {
      const targetIndex = action.payload.targetIndex;
      const newSubtarget = {
        index: action.payload.subtargetIndex,
        id: action.payload.id,
        title: action.payload.subtargetTitle,
        subtitle: action.payload.subtargetSubtitle,
        description: action.payload.subtargetDescription,
        actions: [] as any[],
        _id: action.payload._id,
      };

      state.documents = state.documents.map((document) => {
        if (document._id === state.inEditingDocumentId) {
          document.targets.map((target) => {
            if (target.index === targetIndex) {
              target.subtargets = [...target.subtargets, newSubtarget];
            }
          });
        }
        return document;
      });

    },

    addInEditingDocumentTarget: (state, action) => {
      const newTarget = {
        index: action.payload.targetIndex,
        id: action.payload.id,
        title: action.payload.targetTitle,
        subtitle: action.payload.targetSubtitle,
        description: action.payload.targetDescription,
        subtargets: [] as any[],
        _id: action.payload._id,
      };

      state.documents = state.documents.map((document) => {
        if (document._id === state.inEditingDocumentId) {
          document.targets = [...document.targets, newTarget];
        }
        return document;
      });
    },

    addInEditingDocumentIndicator: (state, action) => {
      const targetIndex = action.payload.targetIndex;
      const subtargetIndex = action.payload.subtargetIndex;
      const actionIndex = action.payload.actionIndex;

      const timePeriods = action.payload.timePeriods;
      let values: { [key: string]: string } = {};
      timePeriods.forEach((timePeriod: any) => {
        values[`${timePeriod}`] = "";
      });

      const newIndicator = {
        index: action.payload.indicatorIndex,
        id: action.payload.id,
        title: action.payload.indicatorTitle,
        subtitle: action.payload.indicatorSubtitle,
        description: action.payload.indicatorDescription,
        attachments: [] as any[],
        oldAttachments: [] as any[],
        inputType: "text",
        placeholder: "",
        values: values,
        _id: action.payload._id,
        pnrr: action.payload.indicatorPnrr ?? [],
        sdg: action.payload.indicatorSdg ?? [],
        sources: action.payload.indicatorSources,
        organizationalUnit: action.payload.organizationalUnit,
        anvur: action.payload.anvur,
        strategicPlan: action.payload.strategicPlan ?? "",
      };


      state.documents = state.documents.map((document) => {
        if (document._id === state.inEditingDocumentId) {
          document.targets.map((target) => {
            if (target.index === targetIndex) {
              target.subtargets.map((subtarget) => {
                if (subtarget.index === subtargetIndex) {
                  subtarget.actions.map((act) => {
                    if (act.index === actionIndex) {
                      act.indicators = [...act.indicators, newIndicator];

                    }

                  });
                }
              });
            }
          })
        }
        return document;
      });
    },

    deleteInEditingDocumentIdicator: (state, action) => {
      const targetIndex = action.payload.targetIndex;
      const subtargetIndex = action.payload.subtargetIndex;
      const actionIndex = action.payload.actionIndex;
      const indicatorIndex = action.payload.indicatorIndex;

      state.documents = state.documents.map((document) => {
        if (document._id === state.inEditingDocumentId) {
          document.targets.map((target) => {
            if (target.index === targetIndex) {
              target.subtargets.map((subtarget) => {
                if (subtarget.index === subtargetIndex) {
                  subtarget.actions.map((act) => {
                    if (act.index === actionIndex) {
                      act.indicators = act.indicators.filter((indicator) => indicator.index !== indicatorIndex);
                    }
                  });
                }
              });
            }
          });
        }
        return document;
      });
    },

    deleteInEditingDocumentAction: (state, action) => {
      const targetIndex = action.payload.targetIndex;
      const subtargetIndex = action.payload.subtargetIndex;
      const actionIndex = action.payload.actionIndex;
      const indexOfTargetToUpdate = state.documents.find((document) => document._id === state.inEditingDocumentId).targets.findIndex(target => target.index === targetIndex);
      const indexOfSubtargetToUpdate = state.documents.find((document) => document._id === state.inEditingDocumentId).targets[indexOfTargetToUpdate].subtargets.findIndex(subtarget => subtarget.index === subtargetIndex);


      state.documents = state.documents.map((document) => {
        if (document._id === state.inEditingDocumentId) {
          document.targets.map((target) => {
            if (target.index === targetIndex) {
              target.subtargets.map((subtarget) => {
                if (subtarget.index === subtargetIndex) {
                  subtarget.actions = subtarget.actions.filter((action) => action.index !== actionIndex);
                }
              });
            }
          });
        }
        return document;
      })

    },

    deleteInEditingDocumentSubtarget: (state, action) => {
      const targetIndex = action.payload.targetIndex;
      const subtargetIndex = action.payload.subtargetIndex;
      state.documents = state.documents.map((document) => {
        if (document._id === state.inEditingDocumentId) {
          document.targets.map((target) => {
            if (target.index === targetIndex) {
              target.subtargets = target.subtargets.filter((subtarget) => subtarget.index !== subtargetIndex);
            }
          });
        }
        return document;
      })
    },
    deleteInEditingDocumentTarget: (state, action) => {
      const targetIndex = action.payload.targetIndex;

      state.documents = state.documents.map((document) => {
        if (document._id === state.inEditingDocumentId) {
          document.targets = document.targets.filter((target) => target.index !== targetIndex);
        }
        return document;
      })

    },
    updateInEditingDocumentIndicators: (state, action) => {
      const targetIndex = action.payload.targetIndex;
      const subtargetIndex = action.payload.subtargetIndex;
      const actionIndex = action.payload.actionIndex;
      const indicators = action.payload.indicators;

      const indexOfTargetToUpdate = state.documents.find((document) => document._id === state.inEditingDocumentId).targets.findIndex(target => target.index === targetIndex);
      const indexOfSubtargetToUpdate = state.documents.find((document) => document._id === state.inEditingDocumentId).targets[indexOfTargetToUpdate].subtargets.findIndex(subtarget => subtarget.index === subtargetIndex);
      const indexOfActionToUpdate = state.documents.find((document) => document._id === state.inEditingDocumentId).targets[indexOfTargetToUpdate].subtargets[indexOfSubtargetToUpdate].actions.findIndex(action => action.index === actionIndex);


      state.documents = state.documents.map((document) => {
        if (document._id === state.inEditingDocumentId) {
          document.targets.map((target) => {
            if (target.index === targetIndex) {
              target.subtargets.map((subtarget) => {
                if (subtarget.index === subtargetIndex) {
                  subtarget.actions.map((act) => {
                    if (act.index === actionIndex) {
                      act.indicators = indicators;
                    }
                  });
                }
              });
            }
          });
        }
        return document;
      })

    },

    updateInEditingDocumentActions: (state, action) => {
      const targetIndex = action.payload.targetIndex;
      const subtargetIndex = action.payload.subtargetIndex;
      const actionIndex = action.payload.actionIndex;
      const actions = action.payload.actions;


      state.documents = state.documents.map((document) => {
        if (document._id === state.inEditingDocumentId) {
          document.targets.map((target) => {
            if (target.index === targetIndex) {
              target.subtargets.map((subtarget) => {
                if (subtarget.index === subtargetIndex) {
                  subtarget.actions = actions;
                }
              });
            }
          });
        }
        return document;
      })
    },
    updateInEditingDocumentSubtargets: (state, action) => {
      const targetIndex = action.payload.targetIndex;
      const subtargets = action.payload.subtargets;


      state.documents = state.documents.map((document) => {
        if (document._id === state.inEditingDocumentId) {
          document.targets.map((target) => {
            if (target.index === targetIndex) {
              target.subtargets = subtargets;
            }
          });
        }
        return document;
      })
    },
    updateInEditingDocumentTargets: (state, action) => {
      const targets = action.payload.targets;

      state.documents = state.documents.map((document) => {
        if (document._id === state.inEditingDocumentId) {
          document.targets = targets;
        }
        return document;
      })
    },

    resetDocumentsState: () => initialState,

    updateSelectedDocumentIndicators: (state, action) => {
      const { indicators, timePeriod, divisions } = action.payload;
      const { selectedDocumentId } = state;
      const selectedDocumentIndex = state.documents.findIndex(document => document._id === selectedDocumentId);

      if (selectedDocumentIndex === -1) return state;

      const updatedDocuments = state.documents.map((document, index) => {
        if (index !== selectedDocumentIndex) {
          return document; // Return other documents unchanged
        } else {
          const updatedTargets = document.targets.map((target: any) => {
            const updatedSubtargets = target.subtargets.map((subtarget: any) => {
              const updatedActions = subtarget.actions.map((action: any) => {
                const updatedIndicators = action.indicators.map((indicator: any) => {
                  for (const key in indicators) {
                    const { targetId, subTargetId, actionId, indicatorId, sourceId } = explodeIndicatorId(key);
                    if (indicator._id === indicatorId && target._id === targetId && subtarget._id === subTargetId && action._id === actionId) {
                      let newValues: any = {}
                      divisions.map((source: any) => {
                        newValues[source.code] = indicators[`indicator-${targetId}-${subTargetId}-${actionId}-${indicatorId}-${source._id}`]
                      })
                      return { ...indicator, values: { ...indicator.values, [timePeriod]: { ...newValues } } };
                    }
                  }
                  return indicator;
                });
                return { ...action, indicators: updatedIndicators };
              });
              return { ...subtarget, actions: updatedActions };
            });
            return { ...target, subtargets: updatedSubtargets };
          });
          return { ...document, targets: updatedTargets };
        }
      });

      return { ...state, documents: updatedDocuments };
    },
    updateSelectedDocumentSubtarget: (state, action) => {
      const { newSubtarget, subTargetId } = action.payload;
      const { selectedDocumentId } = state;



      const selectedDocumentIndex = state.documents.findIndex(document => document._id === selectedDocumentId);

      if (selectedDocumentIndex === -1) return state;

      const updatedDocuments = state.documents.map((document, index) => {
        if (index !== selectedDocumentIndex) {
          return document;
        }

        const updatedTargets = document.targets.map((target: any) => {
          const updatedSubtargets = target.subtargets.map((subtarget: any) => {
            if (subtarget._id === subTargetId) {
              return newSubtarget;
            }
            return subtarget;
          });

          return { ...target, subtargets: updatedSubtargets };
        });

        return { ...document, targets: updatedTargets };
      });

      return { ...state, documents: updatedDocuments };

    },
    resetSelectedDocumentId: (state) => {
      state.selectedDocumentId = "";
    },
    addSource(state, action) {
      const documentId = state.selectedDocumentId
      const targetId = action.payload.targetId;
      const subTargetId = action.payload.subTargetId;
      const actionId = action.payload.actionId;
      const indicatorId = action.payload.indicatorId;
      const source = action.payload.source;

      state.documents = state.documents.map((document) => {
        if (document._id === documentId) {
          document.targets = document.targets.map((target) => {
            if (target._id === targetId) {
              target.subtargets = target.subtargets.map((subtarget) => {
                if (subtarget._id === subTargetId) {
                  subtarget.actions = subtarget.actions.map((act) => {
                    if (act._id === actionId) {
                      act.indicators = act.indicators.map((indicator) => {
                        if (indicator._id === indicatorId) {
                          indicator.attachments = [...indicator.attachments, source];
                          return indicator;
                        }
                        return indicator;
                      });
                    }
                    return act;
                  });
                }
                return subtarget;
              });
            }
            return target;
          });
        }
        return document;
      });
    },
    removeSource(state, action) {
      const documentId = state.selectedDocumentId
      const targetId = action.payload.targetId;
      const subTargetId = action.payload.subTargetId;
      const actionId = action.payload.actionId;
      const indicatorId = action.payload.indicatorId;
      const filename = action.payload.filename;

      state.documents = state.documents.map((document) => {
        if (document._id === documentId) {
          document.targets = document.targets.map((target) => {
            if (target._id === targetId) {
              target.subtargets = target.subtargets.map((subtarget) => {
                if (subtarget._id === subTargetId) {
                  subtarget.actions = subtarget.actions.map((act) => {
                    if (act._id === actionId) {
                      act.indicators = act.indicators.map((indicator) => {
                        if (indicator._id === indicatorId) {
                          indicator.attachments = indicator.attachments.filter((source) => source.filename !== filename);
                          return indicator;
                        }
                        return indicator;
                      });
                    }
                    return act;
                  });
                }
                return subtarget;
              });
            }
            return target;
          });
        }
        return document;
      });
    }
  },


});

export const {
  removeSource,
  addSource,
  resetSelectedDocumentId,
  updateSelectedDocumentSubtarget,
  updateSelectedDocumentIndicators,
  addDocuments,
  addDocument,
  updateDocument,
  removeDocument,
  resetDocumentsState,
  setSelectedDocumentId,
  setDocumentInEditingId,
  removeDocumentInEditingId,
  updateInEditingDocumentTargets,
  updateInEditingDocumentSubtargets,
  updateInEditingDocumentActions,
  updateInEditingDocumentIndicators,
  updateInEditingDocumentTarget,
  updateInEditingDocumentSubtarget,
  updateInEditingDocumentAction,
  updateInEditingDocumentIndicator,
  deleteInEditingDocumentTarget,
  deleteInEditingDocumentSubtarget,
  deleteInEditingDocumentAction,
  deleteInEditingDocumentIdicator,
  addInEditingDocumentTarget,
  addInEditingDocumentSubtarget,
  addInEditingDocumentAction,
  addInEditingDocumentIndicator,
} = DocumentsSlice.actions;
export default DocumentsSlice.reducer;
